import { dataLocation } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLocation = /*#__PURE__*/createIcon(dataLocation)
export default IconLocation
